import { Card, Col, Divider, Radio, Row } from "antd";
import { getEmailSendingSummaryV2, getLineEmailReportsV2, getMostEmailSummaryV2 } from "api";
import { BarChart, LineChart } from "components/chart/ChartDashboard";
import { useState } from "react";
import ReportError from "components/chart/ReportError";
import useReportV2 from "utils/hooks/useReportV2";
import useDocumentTitle from "utils/useDocumentTitle";
import CallToAction from "./CallToAction";
import EmailSendingSummary from "./EmailSendingSummary";
import "./maindashboard.less";

const ChartRadioButton = ({ value, setRadio }) => {
  const onRadioChange = ({ target: { value } }) => setRadio(value);
  return (
    <Radio.Group buttonStyle="solid" onChange={onRadioChange} value={value}>
      <Radio.Button value="week">7 Hari</Radio.Button>
      <Radio.Button value="month">30 Hari</Radio.Button>
    </Radio.Group>
  );
};

const SummaryRadioButton = ({ value, setRadio }) => {
  const onRadioChange = ({ target: { value } }) => setRadio(value);
  return (
    <Radio.Group buttonStyle="solid" value={value} onChange={onRadioChange}>
      <Radio.Button value="allTime">All Time</Radio.Button>
      <Radio.Button value="today">Today</Radio.Button>
      <Radio.Button value="week">7 Hari</Radio.Button>
      <Radio.Button value="month">30 Hari</Radio.Button>
    </Radio.Group>
  );
};

const MainDashboard = () => {
  useDocumentTitle("Dashboard");
  const [statistic, setStatistic] = useState("allTime");
  const [chart, setChart] = useState("week");
  const summary = useReportV2(getEmailSendingSummaryV2, statistic);
  const daily = useReportV2(getLineEmailReportsV2, chart);
  const rankings = useReportV2(getMostEmailSummaryV2, chart);
  const barMostEmailSummary = rankings.data;

  return (
    <div className="main-dashboard-user flex flex-col gap-y-6 px-6 py-4">
      <CallToAction />
      <Card
        title="Email Sending Summary"
        className="card-wrapper-dashboard"
        loading={summary.loading}
        extra={<SummaryRadioButton value={statistic} radio={statistic} setRadio={setStatistic} />}>
        {summary.error ? (
          <ReportError error={summary.error} retry={summary.retry} />
        ) : summary.data ? (
          <Row gutter={[24, 0]} wrap justify="space-between">
            <EmailSendingSummary data={summary.data} />
          </Row>
        ) : null}
      </Card>
      <Card
        title="Grafik Pengiriman Email"
        extra={<ChartRadioButton radio={chart} setRadio={setChart} value={chart} />}
        className="card-wrapper-chart">
        <Row gutter={[24, 24]}>
          <Col xl={18} lg={24} md={24} sm={24}>
            <Card bordered={false} loading={daily.loading}>
              <span className="text-emaildashboard">
                Pengiriman dalam {chart === "month" ? "30 hari" : "7 hari"} termasuk hari ini (WIB)
              </span>
              {daily.error ? (
                <ReportError error={daily.error} retry={daily.retry} />
              ) : (
                <LineChart data={daily.data || []} />
              )}
            </Card>
          </Col>
          <Col xl={6} lg={24} md={24} sm={24} className="column-chart-right">
            <Card bordered={false} loading={rankings.loading}>
              <p className="text-secondary">
                {chart === "month" ? "30" : "7"} hari selesai (WIB), tanpa hari ini
              </p>
              {rankings.error ? (
                <ReportError error={rankings.error} retry={rankings.retry} />
              ) : (
                <Row gutter={[8, 8]}>
                  <Col lg={8} xl={24}>
                    <div className="px-6 py-4">
                      <p className="mb-2">Volume Penerima Terbanyak</p>
                      <BarChart
                        title="Volume Penerima Terbanyak"
                        data={barMostEmailSummary?.top_receiver_domain}
                      />
                      <Divider className="mb-2 mt-4" />
                    </div>
                  </Col>
                  <Col lg={8} xl={24}>
                    <div className="px-6 py-4">
                      <p className="mb-2">Volume Domain Pengirim Terbanyak</p>
                      <BarChart
                        title="Volume Domain Pengirim Terbanyak"
                        data={barMostEmailSummary?.top_sender_domain}
                      />
                      <Divider className="mb-2 mt-4" />
                    </div>
                  </Col>
                  <Col lg={8} xl={24}>
                    <div className="px-6 py-4">
                      <p className="mb-2">Volume Email Pengirim Terbanyak</p>
                      <BarChart
                        title="Volume Email Pengirim Terbanyak"
                        data={barMostEmailSummary?.top_sender_email}
                      />
                      <Divider className="mb-2 mt-4" />
                    </div>
                  </Col>
                </Row>
              )}
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default MainDashboard;
